import { useGetAsset } from "@/entities/asset";
import FetchItemWrapper from "@/modules/fetch-item-wrapper";

import AssetEdit from "./AssetEdit.component";

const AssetEditWrapper = ({ assetId }) => {
  const { asset, isLoading } = useGetAsset(assetId);

  return (
    <FetchItemWrapper
      item={asset}
      loading={isLoading}
      renderContent={(asset) => <AssetEdit model={asset} />}
    />
  );
};

export default AssetEditWrapper;
